import { sanitizeObjectValues } from './sanitizer'

const mergeDefaultTrackingDataAndCustomTrackingData = (
  pageBasicTrackingData,
  customTrackingData
) => {
  const pageBasicTrackingDataEntries = Object.entries(pageBasicTrackingData)
  const customTrackingDataEntries = Object.entries(customTrackingData)

  const merge = [
    ...pageBasicTrackingDataEntries,
    ...customTrackingDataEntries,
  ].reduce((acc, crr) => {
    const [key, value] = crr

    const currentlayerValueIsString = typeof value === 'string'

    if (currentlayerValueIsString) {
      return {
        ...acc,
        [key]: value,
      }
    }

    const layerValuePrevSave = acc[key]
    return {
      ...acc,
      [key]: {
        ...(layerValuePrevSave || {}),
        ...value,
      },
    }
  }, {})

  return merge
}

const parseTrackingData = (pageBasicTrackingData, customTrackingData) => {
  const sanitizedCustomTrackingData = sanitizeObjectValues(
    customTrackingData.data
  )

  const currentDatalayerValue = mergeDefaultTrackingDataAndCustomTrackingData(
    objDataLayer,
    pageBasicTrackingData
  )

  const mappingTrackingDataToDatalayer =
    mergeDefaultTrackingDataAndCustomTrackingData(
      currentDatalayerValue,
      sanitizedCustomTrackingData
    )

  const { eventType } = customTrackingData
  return {
    eventType,
    datalayer: mappingTrackingDataToDatalayer,
  }
}

export { parseTrackingData }
